import axios from 'axios'
import qs from 'qs'
let ROOT;
if (process.env.NODE_ENV === 'development') {
  ROOT = "/";//开发环境下的代理地址，解决本地跨域
} else {
  ROOT = 'hhttp://10.55.1.76:8887';    //生产环境下的地址
}
axios.defaults.baseURL = ROOT
axios.defaults.headers.post['Content-Type'] = 'application/json;'
// axios.defaults.headers.post['ver'] = '1.0'

const fetch = (url, data, method) => {
  let promise
  let option = {
    method,
    url,
    params: {},
  }
  if (method === 'post') {
    option = { ...option, data: data }
  } else if (method === 'get') {
    option = { ...option, params: { ...option.params, ...data } }
  } else if (method === 'delete') {
    option = { ...option, data: qs.stringify(data) }
  }
  promise = promise || axios(option)

  return promise.then(({ data, status, statusText }) => {
    if (status !== 200) {
      throw { statusCode: status, message: statusText }
    }
    return data
  }).then(data => ({ data })).catch(err => {
    return { err }
  })
}

export const get = (url, data = {}) => fetch(url, data, 'get')
export const post = (url, data = {}) => fetch(url, data, 'post')
export const del = (url, data = {}) => fetch(url, data, 'delete')



// WEBPACK FOOTER //
// ./src/service/fetch.js